import { APIStatus } from '@application/common/enums/api-status';
import { createSlice } from '@reduxjs/toolkit';
import { getAllPackagesAsync } from './packageThunk';
const initialState = {
    status: APIStatus.IDLE
};
export const packageStateSlice = createSlice({
    name: 'packages',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getAllPackagesAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getAllPackagesAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.packages = action.payload;
        })
            .addCase(getAllPackagesAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
    }
});
export default packageStateSlice.reducer;
